import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollManager from './components/ScrollManager';
import HomePage from './pages/HomePage';
import PeaceOfMindPage from './pages/PeaceOfMindPage';
import GroupControlsPage from './pages/GroupControlsPage';
import ResolutionCenterPage from './pages/ResolutionCenterPage';
import ExtraBenefitsPage from './pages/ExtraBenefitsPage';
import GroupDiscountsPage from './pages/GroupDiscountsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';

const App = () => (
  // reducedMotion="user" drops transform animations for visitors who prefer reduced motion
  <MotionConfig reducedMotion="user">
    <ScrollManager />
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-ink-950 text-slate-50">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/peace-of-mind" element={<PeaceOfMindPage />} />
          <Route path="/group-controls" element={<GroupControlsPage />} />
          <Route path="/resolution-center" element={<ResolutionCenterPage />} />
          <Route path="/extra-benefits" element={<ExtraBenefitsPage />} />
          <Route path="/group-discounts" element={<GroupDiscountsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </MotionConfig>
);

export default App;
